
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/Akkhor";
import {  useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/Api";
import { useParams } from "react-router-dom";
import ItemRoleRight from "./ItemRoleRight";
import { confirmAlert } from "react-confirm-alert";
import { RolesRight } from "../configs";

const _ = require("lodash")
export default function FormRolesPage() {
    const { user } = useSelector((state) => state.auth);
    const {id}  = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [localRole, setLocalRole] = useState(RolesRight);
    const [checkAllRole, setCheckAllRole] = useState(true);
    const [refresh, setRefresh] = useState(false);
    
    const defaultdetail = { author_id:user.data.id,title:'', status:1,roleright:null}
    useEffect(()=>{
        if(id>0)
        {
            let mounted = true;
            Axios.get(URL_LIST_ALL  + "roles/"+id,user.config)
                .then( async (res) => {
                if (res.data.status === "success") {
                    if (mounted){
                        setDetail(res.data.data);
                        let myrole = JSON.parse(res.data.data.roleright);
                        let newDT =  setRoleChecked(_.assign({},RolesRight),myrole);
                        setLocalRole(newDT);
                    } 
                } else console.log(res.data.message);
                })
                .catch((err) => console.log(err));
                return () => (mounted = false);
        }
    },[user,id,refresh]);// eslint-disable-line


    const setRoleChecked=(main,role) => {
        let newDT = _.assign({},RolesRight,main);
        Object.keys(newDT).map((key)=>{
            let child1 = Object.assign({}, newDT[key]);
            child1.checked = role[key]?role[key].checked:false;
            if(child1.children)
            {
                let children = Object.assign({}, child1.children);
                Object.keys(children).map((key2)=>{
                    let child2 = Object.assign({}, children[key2]);
                    if(role[key] && role[key].children && role[key].children[key2])
                    {
                        child2.checked = role[key].children[key2].checked;
                    }
                    children[key2] = child2;
                    return key2;
                });
                child1.children = children;
            }
            newDT[key] = child1 
            return key;
        });
        return newDT
    }

    const formik = useFormik({
        initialValues:detail?detail:defaultdetail,
        enableReinitialize:true,
        validationSchema: Yup.object().shape({
          title: Yup.string().trim().nullable().required('Nhập tiêu đề quyền hạn').max(150, "Độ dài không quá 150 ký tự"),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            values.roleright = JSON.stringify(localRole);
            setLoading(true)
            if(id>0)
            {
                Axios.put(URL_LIST_ALL+'roles/'+id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                        title: 'Thành công',
                        message: 'Bạn cập nhật quyền thành công',
                        buttons: [{ label: 'OK' }]
                    }); }else{
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }else{
                
                Axios.post(URL_LIST_ALL+'roles', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới quyền thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    }else{
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const setCheckAll = () => {
       
        let newDT = Object.assign({}, RolesRight);
        Object.keys(newDT).map((key)=>{
            let child1 = Object.assign({}, newDT[key]);
            child1.checked = checkAllRole;
            if(child1.children)
            {
                let children = Object.assign({}, child1.children);
                Object.keys(children).map((key2)=>{
                    let child2 = Object.assign({}, children[key2]);
                    child2.checked = checkAllRole;
                    children[key2] = child2;
                    return key2;
                });
                child1.children = children;
            }
            newDT[key] = child1 
            return key;
        });
        setLocalRole(newDT);
        setCheckAllRole(!checkAllRole)
    }
  return (
    <AkkhorLayout idrole="list-roles">
      <div className="card height-auto mt-5">
        <div className="card-body">
            <div className="heading-layout1">
                <div className="item-title">
                    <h3>Quyền hạn</h3>
                </div>
            </div>
            <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                <div className="row">
                    <div className="col-lg-6 col-12 form-group">
                        <label>Tiêu đề <span className="text-danger">*</span></label>
                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off"/>
                        <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                    </div>
                    <div className="col-lg-6 col-12 form-group">
                        <label>Trạng thái</label>
                        <select className="form-control height32" {...formik.getFieldProps("status")}>
                            <option value="0">Khoá</option>
                            <option value="1">Hoạt động</option>
                        </select>
                    </div>
                    <div className="col-12 form-group">
                        <label>Chọn các chức năng cho quyền hạn<span className="text-danger">*</span></label>
                        <button type="button" className="btn btn-sm btn-info mb-2" onClick={setCheckAll}> {(checkAllRole?'Chọn':'Bỏ chọn')+' tất cả'} </button>
                        {Object.keys(localRole).map((key,i)=><ItemRoleRight key={i} RolesRight={localRole[key]} name={key} parent={key} marginleft={1} dt={localRole} onChange={setLocalRole} />)}
                    </div>
                    
                    <div className="col-12 form-group mg-t-8">
                    <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner />:<>Lưu quyền</>}</button>
                        <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                    </div>
                </div>
            </form>
        </div>
      </div>
    </AkkhorLayout>
  );
}
